import BasicModal from "components/Modal";
import { baseURL } from "utils/api";
import React, { useEffect, useState } from 'react'
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SelectLocation from "components/location";
import LocationSearch from "layouts/authentication/sign-up/googleInput";
import toast from "react-hot-toast";
import { Card, CircularProgress } from "@mui/material";
import Logo from 'assets/images/business1Logo.jpg';
import useMediaQuery from '@mui/material/useMediaQuery';
import DummyImage from "assets/images/2665820.jpg";


const index = ({ show, unShow, mainBusiness, setRefresh }) => {

    const matches = useMediaQuery('(max-width:600px)');
    const [loading, setLoading] = useState(false);
    const [addressData, setAddressData] = useState('');
    const [searchFirst, setSearchFirst] = useState(false);
    const [madeChanges, setMadeChanges] = useState(false);
    const [values, setValues] = useState({
        addLine: "",
        subAddLine: "",
        city: "",
        state: "",
        country: "",
        zipcode: "",
        locationName: "",
        latitude: 27.9489075,
        longitude: -82.3548117
    });


    useEffect(() => {
        console.log("addressData",addressData)
        if (addressData) {
            
            setValues({
                ...values,
                addLine: addressData?.address,
                // subAddLine = county (US) / sublocality (non-US); see api/addressFunction.js + backend getDataByLatLng.js
                subAddLine: addressData?.subAddress || "",
                city: addressData?.city,
                state: addressData?.state,
                country: addressData?.country,
                zipcode: addressData?.zipcode,
            });
        }
    }, [addressData]);


    useEffect(() => {
        if (mainBusiness) {
            setValues({
                ...values,
                latitude: mainBusiness?.location?.coordinates[1],
                longitude: mainBusiness?.location?.coordinates[0]

            });
        }
    }, [mainBusiness]);





    const handleSubmitAddress = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            fetch(`${baseURL}createBusiness/${localStorage.getItem("id")}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("token")}`
                },
                body: JSON.stringify(values)
            }).then((res) => res.json())
                .then((data) => {
                    setLoading(false);
                    if (data?.success) {
                        setRefresh(prev => prev + 1);
                        unShow()
                        setValues({
                            addLine: "",
                            subAddLine: "",
                            city: "",
                            state: "",
                            country: "",
                            zipcode: "",
                            locationName: "",
                            latitude: 0,
                            longitude: 0
                        })
                        toast.success("New Address Added !");
                    } else {
                        toast.error(data?.message);
                    }
                })
        } catch (error) {
            setLoading(false);
            toast.error(error?.message);
        }
    };



    return (
        <SoftBox>

            <BasicModal
                show={show}
                unShow={unShow}
                title="Add Address"
                width={800}
                height={700}
            >
                <Card
                    // className="glassmorphism-card"
                    sx={{
                        borderRadius: "0px",
                        boxShadow: "none",
                        padding: "5px 0px 10px 0px",
                        marginBottom: "10px",
                        marginTop: "0px",
                        display: "flex",
                        flexDirection: "column",
                        borderBottom: "1px solid #e0e0e0",
                        // height: matches ? 200 : 125
                    }}
                >
                    <SoftBox
                        display="flex"
                        alignItems="center"
                        // justifyContent="space-between"
                        // flexDirection={matches ? "column" : "row"}
                        gap={2}
                    >
                        <SoftBox>
                            <img
                                src={(mainBusiness?.businessLogo && mainBusiness?.businessLogo != '') ? `${mainBusiness?.businessLogo}` : DummyImage}
                                alt="logo"
                                style={{ width: "60px", height: "60px", borderRadius: "6px" }}
                            />
                        </SoftBox>

                        <SoftBox
                            sx={{ width: "100%" }}>
                            <SoftTypography
                                variant="h6"
                                fontWeight="normal"
                                sx={{ mb: -1 }}
                            >
                                {mainBusiness?.businessName || "Business Name"}
                            </SoftTypography>
                            <SoftTypography
                                variant="caption"
                            >
                                Rest of your business information is taken from this default business profile.
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>
                </Card>
                <form onSubmit={handleSubmitAddress}>

                    <SoftBox>
                        <SoftTypography
                            variant="caption"
                        >
                            Location Name *
                        </SoftTypography>
                        <SoftInput
                            required
                            value={values.locationName}
                            onChange={e => setValues({ ...values, locationName: e.target.value })}
                            name="locationName"
                            placeholder="Home"
                            type="text"
                        />
                    </SoftBox>
                    <SoftBox mt={2}>
                        <LocationSearch setMadeChanges={setMadeChanges} setSearchFirst={setSearchFirst} setValues={setValues} setAddressData={setAddressData} fetchApi={true} />
                    </SoftBox>

                    <SoftBox
                        display="flex"
                        justifyContent="space-between"
                        gap={2}
                        flexWrap={matches ? "wrap" : "nowrap"}
                    >
                        <SoftBox sx={{ width: "100%" }}>
                            <SoftTypography variant="caption" >
                                Address *
                            </SoftTypography>
                            <SoftInput
                                required
                                disabled
                                value={values.addLine}
                                onChange={e => setValues({ ...values, addLine: e.target.value })}
                                name="addLine"
                                placeholder="Address"
                                type="text"
                            />
                        </SoftBox>
                        {/* <SoftBox sx={{ width: "100%" }}>
                            <SoftTypography
                                variant="caption"
                            >
                                Address Line 2
                            </SoftTypography>
                            <SoftInput
                                value={values.subAddLine}
                                onChange={e => setValues({ ...values, subAddLine: e.target.value })}
                                name="subAddLine"
                                placeholder="Address Line 2"
                                type="text"
                            />
                        </SoftBox> */}
                    </SoftBox>

                    <SoftBox mt={2}>
                        <SoftTypography variant="caption">
                            County / area
                        </SoftTypography>
                        <SoftInput
                            disabled
                            value={values.subAddLine}
                            onChange={(e) =>
                                setValues({ ...values, subAddLine: e.target.value })
                            }
                            name="subAddLine"
                            placeholder="From map / search"
                            type="text"
                        />
                    </SoftBox>

                    <SoftBox
                        display="flex"
                        justifyContent="space-between"
                        gap={2}
                        flexWrap={matches ? "wrap" : "nowrap"}
                    >
                        <SoftBox sx={{ width: "100%" }}>
                            <SoftTypography
                                variant="caption"
                            >
                                City *
                            </SoftTypography>
                            <SoftInput
                                required
                                disabled
                                value={values.city}
                                onChange={e => setValues({ ...values, city: e.target.value })}
                                name="city"
                                placeholder="Tampa"
                                type="text"
                            />
                        </SoftBox>

                        <SoftBox sx={{ width: "100%" }}>
                            <SoftTypography
                                variant="caption"
                            >
                                State *
                            </SoftTypography>
                            <SoftInput
                                required
                                disabled
                                value={values.state}
                                onChange={e => setValues({ ...values, state: e.target.value })}
                                name="state"
                                placeholder="FL"
                                type="text"
                            />
                        </SoftBox>

                        <SoftBox sx={{ width: "100%" }}>
                            <SoftTypography
                                variant="caption"
                            >
                                Country *
                            </SoftTypography>
                            <SoftInput
                                required
                                disabled
                                value={values.country}
                                onChange={e => setValues({ ...values, country: e.target.value })}
                                name="country"
                                placeholder="USA"
                                type="text"
                            />
                        </SoftBox>
                    </SoftBox>

                    <SoftBox
                        display="flex"
                        justifyContent="space-between"
                        gap={2}
                        flexWrap={matches ? "wrap" : "nowrap"}
                    >

                        <SoftBox sx={{ width: "100%" }}>
                            <SoftTypography
                                variant="caption"
                            >
                                Zip Code *
                            </SoftTypography>
                            <SoftInput
                                required
                                disabled
                                value={values.zipcode}
                                onChange={e => setValues({ ...values, zipcode: e.target.value })}
                                name="zipcode"
                                placeholder="33602"
                                type="number"
                                min={6}
                            />
                        </SoftBox>

                        <SoftBox sx={{ width: "100%" }}>
                            <SoftTypography
                                variant="caption"
                            >
                                Latitude
                            </SoftTypography>
                            <SoftInput
                                value={values.latitude}
                                disabled
                                name="latitude"
                                placeholder="27.9506"
                                type="text"
                            />
                        </SoftBox>

                        <SoftBox sx={{ width: "100%" }}>
                            <SoftTypography
                                variant="caption"
                            >
                                Longitude
                            </SoftTypography>
                            <SoftInput
                                value={values.longitude}
                                disabled
                                name="longitude"
                                placeholder="-82.4572"
                                type="text"
                            />
                        </SoftBox>
                    </SoftBox>



                    <SoftBox mt={2}>
                        <SelectLocation
                            disabled={!searchFirst}
                            lat={values.latitude} lng={values.longitude} setValues={setValues} setAddressData={setAddressData} fetchApi={true} />
                    </SoftBox>

                    <SoftBox mt={2}
                        display="flex"
                        justifyContent="space-between"
                        gap={2}
                    >
                        <SoftButton
                            fullWidth
                            onClick={() => unShow(false)}
                            variant="outlined"
                            color="info"
                        >
                            Cancel
                        </SoftButton>
                        <SoftButton
                            fullWidth
                            variant="gradient"
                            color="info"
                            type="submit"
                        >
                            {
                                loading ? <CircularProgress size={24} color="white" /> : 'Save'
                            }
                        </SoftButton>

                    </SoftBox>
                </form>
            </BasicModal>


        </SoftBox>
    )
}

export default index